import React from 'react'

function Home() {
  return (
    <main>

      {/* ===================== HERO ===================== */}
      <section className="position-relative pt-sm-8 pt-lg-9 pb-4">
        <div className="position-absolute top-0 end-0 z-index-2 d-none d-md-block rtl-flip">
          <img src="assets/images/elements/grad-shape/07.png" alt="" />
        </div>

        <div className="container pt-4">
          <div className="col-md-9 pe-3">

            <p className="heading-color bg-secondary d-inline-block rounded px-3 py-2 mb-3"
               data-aos="fade-down" data-aos-delay="0">
              <span className="badge bg-dark me-2">New</span>
              Maximize productivity with next-generation software
            </p>

            <h1 className="display-6 fw-semibold mb-4 lh-base"
                data-aos="fade-up" data-aos-delay="100">
              Creating software solutions for your
              <span className="text-primary ityped-cursor-opacity mb-0 d-block d-xxl-inline-block">
                <span className="typed" data-type-text="business&&agency&&startup"></span>
              </span>
            </h1>

            <div className="d-flex gap-3 gap-sm-4 flex-wrap"
                 data-aos="fade-up" data-aos-delay="200">
              <a href="/services" className="btn btn-primary-grad">Explore our work</a>

              <div className="d-flex gap-2 align-items-center">
                <ul className="avatar-group mb-0 align-items-center">
                  <li className="avatar">
                    <img className="avatar-img rounded-circle" src="assets/images/avatar/02.jpg" alt="avatar" />
                  </li>
                  <li className="avatar">
                    <img className="avatar-img rounded-circle" src="assets/images/avatar/05.jpg" alt="avatar" />
                  </li>
                  <li className="avatar">
                    <img className="avatar-img rounded-circle" src="assets/images/avatar/10.jpg" alt="avatar" />
                  </li>
                  <li className="avatar">
                    <img className="avatar-img rounded-circle" src="assets/images/avatar/09.jpg" alt="avatar" />
                  </li>
                </ul>
                <p className="heading-color mb-0">28+ happy clients</p>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ===================== HERO SHOWCASE + LOGO SLIDER ===================== */}
      <section className="bg-secondary position-relative overflow-hidden">
        <span className="position-absolute top-0 start-0">
          <svg className="fill-body" width="1920" height="237" viewBox="0 0 1920 237" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1940.5 0H-9V164C708.2 295.2 1589.5 218.667 1940.5 164V0Z" />
          </svg>
        </span>

        <div className="container position-relative z-index-9">
          <div className="position-absolute top-0 start-50 translate-middle-x mt-n3">
            <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" className="opacity-2 blur-8" alt="Grad shape" />
          </div>

          {/* App preview card */}
          <div className="bg-body bg-opacity-10 bg-blur border border-white border-opacity-25 position-relative rounded-4 shadow-primary-lg p-4"
               data-aos="fade-up" data-aos-delay="0">
            <span className="text-purple">
              <svg className="mt-n4" width="40" height="10" viewBox="0 0 40 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5Z" fill="currentColor" />
                <path d="M25 5C25 7.76142 22.7614 10 20 10C17.2386 10 15 7.76142 15 5C15 2.23858 17.2386 0 20 0C22.7614 0 25 2.23858 25 5Z" fill="currentColor" />
                <path d="M40 5C40 7.76142 37.7614 10 35 10C32.2386 10 30 7.76142 30 5C30 2.23858 32.2386 0 35 0C37.7614 0 40 2.23858 40 5Z" fill="currentColor" />
              </svg>
            </span>

            <div className="row rounded-4 overflow-hidden g-0">
              <div className="col-sm-5">
                <div className="card card-body p-0 h-100">
                  <img src="assets/images/bg/02.jpg" alt="" />
                  <div className="card-img-overlay d-flex flex-column">
                    <ul className="list-inline d-flex gap-3 mb-1 mt-auto mx-auto">
                      <li className="list-inline-item me-0">
                        <button className="btn btn-lg btn-white btn-icon rounded-circle mb-0" type="button">
                          <i className="bi bi-mic"></i>
                        </button>
                      </li>
                      <li className="list-inline-item me-0">
                        <button className="btn btn-lg btn-white btn-icon rounded-circle mb-0" type="button">
                          <i className="bi bi-camera-reels"></i>
                        </button>
                      </li>
                      <li className="list-inline-item me-0">
                        <button className="btn btn-lg btn-danger btn-icon rounded-circle mb-0" type="button">
                          <i className="bi bi-telephone-x"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-sm-7">
                <div className="h-100" style={{ backgroundImage: "url(assets/images/bg/code.jpg)", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "left top" }}></div>
              </div>
            </div>
          </div>


          {/* Logo slider — loop + autoplay enabled (#8) */}
          <div className="swiper mt-6"
               data-swiper-options='{"slidesPerView":2,"spaceBetween":50,"loop":true,"autoplay":{"delay":0,"disableOnInteraction":false},"speed":3000,"freeMode":true,"breakpoints":{"576":{"slidesPerView":3},"768":{"slidesPerView":4},"1200":{"slidesPerView":6},"1400":{"slidesPerView":8}}}'>
            <div className="swiper-wrapper align-items-center">
              {[1,2,3,4,5,6,7,8,9].map(n => (
                <div className="swiper-slide" key={n}>
                  <div className="swap-logo">
                    <img src={`assets/images/client/logo-gray/0${n}.svg`} alt="client-img" />
                    <div className="swap-item">
                      <img src={`assets/images/client/logo-light/0${n}.svg`} className="dark-mode-item" alt="client logo" />
                      <img src={`assets/images/client/logo-dark/0${n}.svg`} className="light-mode-item" alt="client logo" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>


      {/* ===================== ABOUT / INNOVATION ===================== */}
      <section className="bg-secondary pt-0 overflow-hidden">
        <div className="container">
          <div className="row g-4">

            <div className="col-lg-5" data-aos="fade-right" data-aos-delay="0">
              <h2 className="mb-2 mb-lg-4">Leading the future of software innovation</h2>
              <p className="mb-2 mb-lg-4">Our expert team is dedicated to understanding your unique needs and delivering solutions that exceed expectations.</p>

              <ul className="list-group list-group-borderless mb-3 mb-lg-4">
                <li className="list-group-item d-flex heading-color fw-semibold pb-0">
                  <i className="bi bi-check-circle text-primary me-2"></i>Collaborative approach
                </li>
                <li className="list-group-item d-flex heading-color fw-semibold pb-0">
                  <i className="bi bi-check-circle text-primary me-2"></i>Agile development methodology
                </li>
                <li className="list-group-item d-flex heading-color fw-semibold pb-0">
                  <i className="bi bi-check-circle text-primary me-2"></i>Data security and compliance
                </li>
              </ul>

              <div className="d-flex gap-3 flex-wrap">
                <a href="/about" className="btn btn-primary mb-0">Learn more</a>
                <a href="/contact" className="link-primary-grad icon-link icon-link-hover">
                  Schedule a consultation <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-6 position-relative ms-auto ps-lg-4" data-aos="fade-left" data-aos-delay="100">
              <div className="position-absolute start-0 bottom-0 ms-n6 mb-5 d-none d-sm-block">
                <img src="assets/images/elements/grad-shape/08.png" className="blur-1 z-index-9 position-relative" alt="shape decoration" />
              </div>
              <div className="position-absolute top-50 start-0 translate-middle-y ms-n4 mt-n7">
                <img src="assets/images/elements/grad-shape/blur-decoration.svg" className="blur-7 opacity-1" alt="Grad shape" />
              </div>
              <img src="assets/images/about/04.jpg" className="rounded-4 position-relative z-index-2" alt="about image" />
            </div>

          </div>
        </div>
      </section>


      {/* ===================== STATS / COUNTER (#7) ===================== */}
      <section className="bg-secondary pt-0 pb-0">
        <div className="container">
          <div className="row g-4 g-lg-5 justify-content-center text-center">

            <div className="col-6 col-md-3" data-aos="zoom-in" data-aos-delay="0">
              <div className="p-3">
                <h2 className="display-5 fw-bold text-primary mb-0">
                  <span className="purecounter" data-purecounter-start="0" data-purecounter-end="28" data-purecounter-duration="2">0</span>+
                </h2>
                <p className="mb-0">Happy clients</p>
              </div>
            </div>

            <div className="col-6 col-md-3" data-aos="zoom-in" data-aos-delay="100">
              <div className="p-3">
                <h2 className="display-5 fw-bold text-primary mb-0">
                  <span className="purecounter" data-purecounter-start="0" data-purecounter-end="35" data-purecounter-duration="2">0</span>+
                </h2>
                <p className="mb-0">Projects delivered</p>
              </div>
            </div>

            <div className="col-6 col-md-3" data-aos="zoom-in" data-aos-delay="200">
              <div className="p-3">
                <h2 className="display-5 fw-bold text-primary mb-0">
                  <span className="purecounter" data-purecounter-start="0" data-purecounter-end="3" data-purecounter-duration="2">0</span>+
                </h2>
                <p className="mb-0">Years of experience</p>
              </div>
            </div>

            <div className="col-6 col-md-3" data-aos="zoom-in" data-aos-delay="300">
              <div className="p-3">
                <h2 className="display-5 fw-bold text-primary mb-0">
                  <span className="purecounter" data-purecounter-start="0" data-purecounter-end="90" data-purecounter-duration="2">0</span>%
                </h2>
                <p className="mb-0">Client satisfaction</p>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ===================== SERVICES (#6 — SVG attributes camelCased) ===================== */}
      <section className="bg-secondary position-relative overflow-hidden pt-0">
        <div className="container position-relative">

          <div className="inner-container-small text-center mb-6 mb-lg-7" data-aos="fade-down" data-aos-delay="0">
            <h2 className="mb-0">Our expert services</h2>
          </div>

          <div className="row g-4 g-xl-5">
            {/* Service 1 */}
            <div className="col-sm-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="0">
              <div className="card card-hover-shadow card-icon-transition text-center bg-body bg-opacity-50 bg-blur rounded-4 h-100 p-4">
                <div className="card-icon icon-xl bg-pink d-flex justify-content-center align-items-center text-white rounded-circle">
                  <svg width="40" height="40" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.5587 22.5601C22.1315 22.9872 22.1315 23.6797 22.5587 24.1068C22.9858 24.534 23.6782 24.534 24.1054 24.1068L22.5587 22.5601ZM29.1654 17.5001L29.9387 18.2735C30.1439 18.0684 30.2591 17.7902 30.2591 17.5001C30.2591 17.2101 30.1439 16.9318 29.9387 16.7268L29.1654 17.5001ZM24.1054 10.8934C23.6782 10.4663 22.9858 10.4663 22.5587 10.8934C22.1315 11.3205 22.1315 12.0131 22.5587 12.4402L24.1054 10.8934ZM12.4388 12.4402C12.8659 12.0131 12.8659 11.3205 12.4388 10.8934C12.0116 10.4663 11.3191 10.4663 10.892 10.8934L12.4388 12.4402ZM5.83203 17.5001L5.05863 16.7268C4.85352 16.9318 4.73828 17.2101 4.73828 17.5001C4.73828 17.7902 4.85352 18.0684 5.05863 18.2735L5.83203 17.5001ZM10.892 24.1068C11.3191 24.534 12.0116 24.534 12.4388 24.1068C12.8659 23.6797 12.8659 22.9872 12.4388 22.5601L10.892 24.1068ZM13.5304 27.408C13.3644 27.9887 13.7007 28.5941 14.2816 28.7601C14.8623 28.926 15.4677 28.5897 15.6336 28.0089L13.5304 27.408ZM21.467 7.59226C21.6329 7.01144 21.2966 6.40607 20.7158 6.24012C20.1351 6.07416 19.5297 6.41049 19.3638 6.99131L21.467 7.59226ZM24.1054 24.1068L29.9387 18.2735L28.392 16.7268L22.5587 22.5601L24.1054 24.1068ZM29.9387 16.7268L24.1054 10.8934L22.5587 12.4402L28.392 18.2735L29.9387 16.7268ZM10.892 10.8934L5.05863 16.7268L6.60543 18.2735L12.4388 12.4402L10.892 10.8934ZM5.05863 18.2735L10.892 24.1068L12.4388 22.5601L6.60543 16.7268L5.05863 18.2735ZM15.6336 28.0089L21.467 7.59226L19.3638 6.99131L13.5304 27.408L15.6336 28.0089Z" fill="currentColor" />
                  </svg>
                </div>
                <div className="card-footer bg-transparent mt-6 p-0">
                  <h6 className="mb-3">Software development</h6>
                  <p>Transform your unique ideas into reality with our services.</p>
                  <a href="/webdev" className="link-primary-grad icon-link icon-link-hover stretched-link mb-0">
                    Read more <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>


            {/* Service 2 */}
            <div className="col-sm-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="100">
              <div className="card card-hover-shadow card-icon-transition text-center bg-body bg-opacity-50 bg-blur rounded-4 h-100 p-4">
                <div className="card-icon icon-xl bg-purple d-flex justify-content-center align-items-center text-white rounded-circle">
                  <svg width="35" height="35" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.99982 16.6666C7.03588 17.5593 6.0539 18.0056 5.66258 18.5624C5.05648 19.4249 5.05648 20.5749 5.66258 21.4374C6.0539 21.9943 7.03588 22.4406 8.99982 23.3333M8.99982 16.6666C7.03588 15.7739 6.0539 15.3276 5.66258 14.7707C5.05648 13.9083 5.05648 12.7583 5.66258 11.8958C6.0539 11.339 7.03588 10.8926 8.99982 9.99994L18.1376 5.84636C18.951 5.47673 19.3575 5.29189 19.7868 5.25519C19.9285 5.24306 20.0711 5.24306 20.2128 5.25519C20.6421 5.29189 21.0486 5.47673 21.862 5.84636L30.9998 9.99994C32.9638 10.8926 33.9457 11.339 34.337 11.8958C34.9432 12.7583 34.9432 13.9083 34.337 14.7707C33.9457 15.3276 32.9638 15.7739 30.9998 16.6666M8.99982 16.6666L18.1376 20.8203C18.951 21.1898 19.3575 21.3746 19.7868 21.4114C19.9285 21.4234 20.0711 21.4234 20.2128 21.4114C20.6421 21.3746 21.0486 21.1898 21.862 20.8203L30.9998 16.6666M8.99982 23.3333C7.03588 24.2259 6.0539 24.6723 5.66258 25.2291C5.05648 26.0916 5.05648 27.2416 5.66258 28.1041C6.0539 28.6609 7.03588 29.1073 8.99982 29.9999L18.1376 34.1536C18.951 34.5231 19.3575 34.7079 19.7868 34.7448C19.9285 34.7568 20.0711 34.7568 20.2128 34.7448C20.6421 34.7079 21.0486 34.5231 21.862 34.1536L30.9998 29.9999C32.9638 29.1073 33.9457 28.6609 34.337 28.1041C34.9432 27.2416 34.9432 26.0916 34.337 25.2291C33.9457 24.6723 32.9638 24.2259 30.9998 23.3333M8.99982 23.3333L18.1376 27.4869C18.951 27.8564 19.3575 28.0413 19.7868 28.0781C19.9285 28.0901 20.0711 28.0901 20.2128 28.0781C20.6421 28.0413 21.0486 27.8564 21.862 27.4869L30.9998 23.3333M30.9998 16.6666C32.9638 17.5593 33.9457 18.0056 34.337 18.5624C34.9432 19.4249 34.9432 20.5749 34.337 21.4374C33.9457 21.9943 32.9638 22.4406 30.9998 23.3333" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="card-footer bg-transparent mt-6 p-0">
                  <h6 className="mb-3">Consultancy & Strategy</h6>
                  <p>Our experienced consultants work closely with you to assess.</p>
                  <a href="/consulting" className="link-primary-grad icon-link icon-link-hover stretched-link mb-0">
                    Read more <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>


            {/* Service 3 */}
            <div className="col-sm-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="card card-hover-shadow card-icon-transition text-center bg-body bg-opacity-50 bg-blur rounded-4 h-100 p-4">
                <div className="card-icon icon-xl bg-warning d-flex justify-content-center align-items-center text-white rounded-circle">
                  <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.9076 8.95361L11.4613 10.3868C10.8209 10.5554 10.5007 10.6396 10.2575 10.8362C10.1776 10.9008 10.1047 10.9737 10.0401 11.0536C9.84355 11.2968 9.75929 11.617 9.59077 12.2574L6.51585 23.9421C5.73018 26.9276 5.33735 28.4204 5.95407 29.3682C6.14829 29.6667 6.40282 29.9212 6.7013 30.1154C7.64911 30.7322 9.14189 30.3393 12.1274 29.5536L23.8121 26.4787C24.4525 26.3102 24.7727 26.2259 25.0159 26.0294C25.0958 25.9648 25.1687 25.8919 25.2333 25.812C25.4299 25.5688 25.5141 25.2486 25.6827 24.6082L27.1159 19.1619M16.9076 8.95361L27.1159 19.1619M16.9076 8.95361L19.4264 6.43477C20.1997 5.66143 20.5864 5.27475 21.0544 5.20063C21.2056 5.17669 21.3595 5.17669 21.5107 5.20063C21.9787 5.27475 22.3654 5.66143 23.1387 6.43477L29.6347 12.9308C30.4081 13.7041 30.7947 14.0908 30.8689 14.5588C30.8928 14.71 30.8928 14.8639 30.8689 15.0151C30.7947 15.4831 30.4081 15.8698 29.6347 16.6431L27.1159 19.1619" stroke="currentColor" strokeWidth="2.1875" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M14.9023 21.1742C13.8452 20.1171 13.8452 18.4032 14.9023 17.3461C15.9595 16.2889 17.6734 16.2889 18.7305 17.3461C19.7876 18.4032 19.7876 20.1171 18.7305 21.1742C17.6734 22.2313 15.9595 22.2313 14.9023 21.1742ZM14.9023 21.1742L11.0742 25.0023" stroke="currentColor" strokeWidth="2.1875" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="card-footer bg-transparent mt-6 p-0">
                  <h6 className="mb-3">UX/UI design</h6>
                  <p>Talented designers combine creativity with user-centric design.</p>
                  <a href="/services" className="link-primary-grad icon-link icon-link-hover stretched-link mb-0">
                    Read more <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>


            {/* Service 4 */}
            <div className="col-sm-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="300">
              <div className="card card-hover-shadow card-icon-transition text-center bg-body bg-opacity-50 bg-blur rounded-4 h-100 p-4">
                <div className="card-icon icon-xl bg-primary d-flex justify-content-center align-items-center text-white rounded-circle">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 5V8.33333M20 5C15.8579 5 12.1079 6.67893 9.3934 9.3934M20 5C24.1418 5 27.8917 6.67875 30.6062 9.39295M9.3934 9.3934C6.67893 12.1079 5 15.8579 5 20M9.3934 9.3934L11.7488 11.7488M30.6062 9.39295C33.3208 12.1074 35 15.8576 35 20M30.6062 9.39295L28.2492 11.75M5 20H8.33333M5 20C5 24.1418 6.67875 27.8917 9.39295 30.6062M9.39295 30.6062C12.1074 33.3208 15.8576 35 20 35M9.39295 30.6062L11.75 28.2492M35 20H31.6667M35 20C35 24.1422 33.321 27.8922 30.6067 30.6067M30.6067 30.6067C27.8922 33.321 24.1422 35 20 35M30.6067 30.6067L28.248 28.248M20 35V31.6667M19.9993 17.5C21.38 17.5 22.5 18.6193 22.5 20C22.5 21.3807 21.3807 22.5 20 22.5C18.6193 22.5 17.5 21.3803 17.5 19.9997C17.5 18.6193 18.619 17.5 19.9993 17.5ZM19.9993 17.5V12.9167" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="card-footer bg-transparent mt-6 p-0">
                  <h6 className="mb-3">Quality assurance</h6>
                  <p>From functional testing to performance testing, our meticulous.</p>
                  <a href="/services" className="link-primary-grad icon-link icon-link-hover stretched-link mb-0">
                    Read more <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>


            {/* Service 5 */}
            <div className="col-sm-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="400">
              <div className="card card-hover-shadow card-icon-transition text-center bg-body bg-opacity-50 bg-blur rounded-4 h-100 p-4">
                <div className="card-icon icon-xl bg-success d-flex justify-content-center align-items-center text-white rounded-circle">
                  <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.79167 24.1979V24.1979C6.64783 24.1979 5.5866 23.5194 5.2982 22.4125C5.02201 21.3525 4.875 20.2403 4.875 19.0938C4.875 11.845 10.7513 5.96875 18 5.96875C25.2487 5.96875 31.125 11.845 31.125 19.0938C31.125 20.2403 30.978 21.3525 30.7018 22.4125C30.4134 23.5194 29.3522 24.1979 28.2083 24.1979V24.1979M25.2917 30.0313V30.0313C26.9025 30.0313 28.2083 28.7254 28.2083 27.1146V21.2813C28.2083 19.6704 26.9025 18.3646 25.2917 18.3646V18.3646C23.6808 18.3646 22.375 19.6704 22.375 21.2813V27.1146C22.375 28.7254 23.6808 30.0313 25.2917 30.0313ZM10.7083 30.0313V30.0313C12.3192 30.0313 13.625 28.7254 13.625 27.1146V21.2813C13.625 19.6704 12.3192 18.3646 10.7083 18.3646V18.3646C9.0975 18.3646 7.79167 19.6704 7.79167 21.2813V27.1146C7.79167 28.7254 9.0975 30.0313 10.7083 30.0313Z" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="card-footer bg-transparent mt-6 p-0">
                  <h6 className="mb-3">Maintenance & Support</h6>
                  <p>Keep your software running smoothly with our maintenance.</p>
                  <a href="/services" className="link-primary-grad icon-link icon-link-hover stretched-link mb-0">
                    Read more <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Service 6 — CTA */}
            <div className="col-sm-6 col-lg-4 mb-4" data-aos="fade-up" data-aos-delay="500">
              <div className="d-flex flex-column justify-content-center align-items-center text-center h-100">
                <img src="assets/images/elements/emoji.png" className="mb-3" alt="" />
                <p>Not satisfied yet?</p>
                <a href="/services" className="btn btn-primary-grad mb-0">Explore all services</a>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ===================== VIDEO / METHODOLOGY ===================== */}
      <section className="bg-body position-relative overflow-hidden">
        <div className="bg-dark h-500px w-100 position-absolute top-0 start-0">
          <div className="position-absolute top-0 start-0 translate-middle">
            <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" className="opacity-1 blur-8" alt="Grad shape" />
          </div>
          <span className="position-absolute start-0 bottom-0">
            <svg className="fill-body" width="1920" height="99" viewBox="0 0 1920 99" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 93L1946 0V99H0V93Z" />
            </svg>
          </span>
        </div>

        <div className="container position-relative">
          <div className="row mb-4 mb-md-6" data-aos="fade-up" data-aos-delay="0">
            <div className="col-md-6">
              <h2 className="text-white mb-0">Mastering every step of our methodology</h2>
            </div>
          </div>

          <div className="bg-parallax position-relative h-400px h-xl-500px rounded-4 overflow-hidden"
               style={{ backgroundImage: "url(assets/images/about/05.jpg)", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}
               data-aos="zoom-in" data-aos-delay="100">
            <div className="bg-overlay bg-purple opacity-1"></div>
            <div className="position-absolute top-50 start-50 translate-middle z-index-2">
              <a href="https://www.youtube.com/embed/tXHviS-4ygo"
                 className="btn btn-icon btn-xl btn-white btn-round mb-0"
                 data-glightbox="" data-gallery="Video">
                <i className="bi bi-play-fill fa-lg"></i>
              </a>
            </div>
          </div>

          <div className="inner-container-small bg-body shadow-primary rounded-3 text-center py-3 mt-5"
               data-aos="fade-up" data-aos-delay="150">
            <p className="mb-0 px-2 px-sm-5 px-md-0">
              🚀 Need any help or questions, don't worry!{' '}
              <a href="/contact" className="fw-semibold heading-color hover-underline-animation">Hit the button</a>
            </p>
          </div>
        </div>
      </section>


      {/* ===================== TESTIMONIALS ===================== */}
      <section className="bg-body position-relative pt-0 pb-5 pb-sm-0">
        <div className="position-absolute top-100 start-0 translate-middle z-index-2 ms-5 ms-xl-9 mt-5 d-none d-sm-block">
          <img src="assets/images/elements/grad-shape/10.png" className="h-500px h-xl-700px rtl-flip" alt="" />
        </div>

        <div className="container position-relative z-index-9">

          <div className="row align-items-center mb-4 mb-md-5">
            <div className="col-md-7 col-lg-5" data-aos="fade-right" data-aos-delay="0">
              <h2 className="mb-0">What our clients say</h2>
            </div>
            <div className="col-md-5 ms-sm-auto text-sm-end mt-5 mt-sm-0">
              <div className="d-flex gap-2 justify-content-sm-end">
                <a href="#" className="btn btn-primary-grad btn-icon btn-lg rounded-circle mb-0 swiper-button-prev">
                  <i className="bi bi-arrow-left fa-sm"></i>
                </a>
                <a href="#" className="btn btn-primary-grad btn-icon btn-lg rounded-circle mb-0 swiper-button-next">
                  <i className="bi bi-arrow-right fa-sm"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Testimonial swiper */}
          <div className="swiper"
               data-swiper-options='{"spaceBetween":30,"breakpoints":{"576":{"slidesPerView":1},"768":{"slidesPerView":2},"992":{"slidesPerView":3}},"navigation":{"nextEl":".swiper-button-next","prevEl":".swiper-button-prev"}}'
               data-aos="fade-up" data-aos-delay="100">
            <div className="swiper-wrapper">
              {[
                { stars: 4.5, text: 'Their team went above and beyond to understand our needs and deliver a solution that exceeded our expectations. They demonstrated throughout the process was truly impressive.', avatar: '09.jpg', name: 'Jay Patel', role: 'Product designer' },
                { stars: 5, text: 'Frequently partiality possession resolution at or appearance unaffected me. Ye goodness felicity do disposal dwelling no.', avatar: '10.jpg', name: 'Mihir Shah', role: 'Web Developer' },
                { stars: 4.5, text: 'Was out laughter raptures returned outweigh. Luckily cheered colonel I do we attack highest enabled. Tried law yet style child. The bore of true of no be deal.', avatar: '04.jpg', name: 'Dimple khatri', role: 'UI/UX designer' },
                { stars: 4.5, text: 'Our passion for customer excellence is just one reason why we are the market leader. We have always worked very hard to give our customers the best experience.', avatar: '07.jpg', name: 'Sanjana Choudry', role: 'Manager' },
                { stars: 4.5, text: 'Was out laughter raptures returned outweigh. Luckily cheered colonel I do we attack highest enabled. Tried law yet style child. The bore of true of no be deal.', avatar: '01.jpg', name: 'Satyam Patil', role: 'UI/UX designer' },
              ].map((t, i) => (
                <div className="swiper-slide" key={i}>
                  <div className="card bg-secondary bg-opacity-50 bg-blur rounded-4 p-4 h-100">
                    <div className="card-body p-0 mb-4">
                      <ul className="list-inline mb-3">
                        {[...Array(Math.floor(t.stars))].map((_, idx) => (
                          <li className="list-inline-item me-0" key={idx}>
                            <i className="bi bi-star-fill text-warning"></i>
                          </li>
                        ))}
                        {t.stars % 1 !== 0 && (
                          <li className="list-inline-item me-0">
                            <i className="bi bi-star-half text-warning"></i>
                          </li>
                        )}
                      </ul>
                      <blockquote>
                        <p className="heading-color mb-0">{t.text}</p>
                      </blockquote>
                    </div>
                    <div className="card-footer bg-transparent p-0">
                      <div className="d-flex align-items-center">
                        <div className="avatar flex-shrink-0">
                          <img className="avatar-img rounded-circle" src={`assets/images/avatar/${t.avatar}`} alt="avatar" />
                        </div>
                        <div className="ms-3">
                          <p className="lead heading-color fw-semibold mb-0">{t.name}</p>
                          <small>{t.role}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>


      {/* ===================== PRICING ===================== */}
      <section className="bg-secondary position-relative overflow-hidden">
        <span>
          <svg className="position-absolute top-0 start-0 mt-lg-n6" viewBox="0 0 1950 237" style={{ enableBackground: "new 0 0 1950 237" }} xmlSpace="preserve">
            <path className="fill-body" d="M1949.5,0H0v164c717.2,131.2,1598.5,54.7,1949.5,0V0z" />
          </svg>
        </span>

      </section>


      {/* ===================== FAQ ===================== */}
      <section className="bg-secondary pt-0 position-relative">
        <div className="position-absolute end-0 bottom-0 d-none d-sm-block">
          <img src="assets/images/elements/grad-shape/12.png" className="blur-2" alt="Decoration shape" />
        </div>

        <div className="container position-relative">

          <div className="inner-container position-relative text-center mb-4 mb-md-5" data-aos="fade-down" data-aos-delay="0">
            <h2 className="mb-0">Got questions? (FAQs)</h2>
          </div>

          <div className="row">
            <div className="col-lg-8 mx-auto" data-aos="fade-up" data-aos-delay="100">

              <div className="accordion accordion-bg-body-light" id="accordionFaq">

                <div className="accordion-item mb-4">
                  <div className="accordion-header font-base" id="heading-1">
                    <button className="accordion-button fw-semibold rounded" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                      How do I get started with your service?
                    </button>
                  </div>
                  <div id="collapse-1" className="accordion-collapse collapse show" aria-labelledby="heading-1" data-bs-parent="#accordionFaq">
                    <div className="accordion-body pt-0">
                      The first step is to sign up for our service. You can do this by visiting our website and locating the sign-up or registration button. Click on it and follow the prompts to create your account.
                    </div>
                  </div>
                </div>

                <div className="accordion-item mb-4">
                  <div className="accordion-header font-base" id="heading-2">
                    <button className="accordion-button fw-semibold rounded collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="false" aria-controls="collapse-2">
                      What payment methods do you accept?
                    </button>
                  </div>
                  <div id="collapse-2" className="accordion-collapse collapse" aria-labelledby="heading-2" data-bs-parent="#accordionFaq">
                    <div className="accordion-body pt-0">
                      September how men saw tolerably two behavior arranging. She offices for highest and replied one venture pasture. Applauded no discovery in newspaper allowance am northward. Frequently partiality possession resolution at or appearance unaffected me. Engaged its was the evident pleased husband. Ye goodness felicity do disposal dwelling no. First am plate jokes to began to cause a scale.
                    </div>
                  </div>
                </div>

                <div className="accordion-item mb-4">
                  <div className="accordion-header font-base" id="heading-3">
                    <button className="accordion-button fw-semibold collapsed rounded" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-3" aria-expanded="false" aria-controls="collapse-3">
                      How can I contact your customer support team?
                    </button>
                  </div>
                  <div id="collapse-3" className="accordion-collapse collapse" aria-labelledby="heading-3" data-bs-parent="#accordionFaq">
                    <div className="accordion-body pt-0">
                      Agencies provide a wide range of services depending on their specialization. Some common services include advertising campaigns, digital marketing, branding, creative design, media planning and buying, public relations, talent management, event planning, and market research.
                    </div>
                  </div>
                </div>

                <div className="accordion-item mb-4">
                  <div className="accordion-header font-base" id="heading-4">
                    <button className="accordion-button fw-semibold collapsed rounded" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-4" aria-expanded="false" aria-controls="collapse-4">
                      Do you offer custom solutions for businesses?
                    </button>
                  </div>
                  <div id="collapse-4" className="accordion-collapse collapse" aria-labelledby="heading-4" data-bs-parent="#accordionFaq">
                    <div className="accordion-body pt-0">
                      When selecting an agency, consider your specific requirements, budget, and the agency's expertise and track record in your industry. Research their portfolio, client testimonials, and case studies to gauge their capabilities. It's also important to meet with the agency to assess their communication style and ensure they align with your goals.
                    </div>
                  </div>
                </div>

              </div>

              <p className="heading-color text-center">
                Confused? Our team is ready to assist you! Start a chat for quick support.{' '}
                <a href="#" className="hover-underline-animation fw-semibold">Talk to Us</a>
              </p>

            </div>
          </div>

        </div>
      </section>


      {/* ===================== CTA CARDS ===================== */}
      <section className="bg-secondary overflow-hidden pt-0 pb-5 mb-n8">
        <div className="container z-index-9 position-relative">
          <div className="row g-5">

            {/* Newsletter card */}
            <div className="col-xl-6" data-aos="fade-right" data-aos-delay="0">
              <div className="card bg-primary h-100">
                <div className="position-absolute bottom-0 end-0 me-n6 mb-n5 d-none d-sm-block">
                  <img src="assets/images/elements/rocket-02.png" alt="rocket image" />
                </div>
                <div className="row align-items-center h-100 p-3 p-sm-4">
                  <div className="col-sm-8 d-flex h-100">
                    <div className="card-body d-flex flex-column text-white">
                      <h4 className="mb-5 text-white">Stay connected with us</h4>
                      <div className="mt-auto">
                        <form className="input-group mb-2">
                          <input className="form-control form-control-sm rounded border me-3" type="email" placeholder="Enter your email" />
                          <button type="button" className="btn btn-sm btn-dark px-3 rounded-2 mb-0">
                            <i className="bi bi-send-fill"></i>
                          </button>
                        </form>
                        <p className="small mb-0">✌️ No Spam — We Promise!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Career card */}
            <div className="col-xl-6" data-aos="fade-left" data-aos-delay="100">
              <div className="card bg-primary-grad h-100 overflow-hidden">
                <div className="position-absolute end-0 top-0 me-n8 d-none d-sm-block">
                  <img src="assets/images/elements/person-laptop.png" alt="" />
                </div>
                <div className="row align-items-center p-3 p-sm-4">
                  <div className="col-sm-8">
                    <div className="card-body text-white">
                      <p>Apply to work with us</p>
                      <h4 className="mb-5 text-white">Explore Career Opportunities</h4>
                      <a className="btn btn-sm btn-dark icon-link icon-link-hover" href="/contact">
                        View open positions<i className="bi bi-arrow-right"></i>
                      </a>
                      {/* <p className="small mb-0">3 jobs are available</p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

    </main>
  )
}

export default Home
